import { AppJsonDecoder } from 'src/app/utils/app-json-decoder';

export class PurchasesTracesCategoryStatistics {
  category?: string;
  totalAmount?: number;
  percentageOnYearTotal?: number;

  constructor(json?: any) {
    if (!json) return;
    this.category = json.category;
    this.totalAmount = AppJsonDecoder.optPriceValue(json.totalAmount);
    this.percentageOnYearTotal = json.percentageOnYearTotal;
  }
}

export class PurchasesTracesMonthCategoryStatistics {
  category?: string;
  count?: number;
  totalAmount?: number;
  percentageOnMonthTotal?: number;
  percentageOnYearTotal?: number;

  constructor(json?: any) {
    if (!json) return;
    this.category = json.category;
    this.count = json.count;
    this.totalAmount = AppJsonDecoder.optPriceValue(json.totalAmount);
    this.percentageOnMonthTotal = json.percentageOnMonthTotal;
    this.percentageOnYearTotal = json.percentageOnYearTotal;
  }
}

export class PurchasesTracesMonthStatistics {
  month?: number;
  name?: string;
  count?: number;
  totalAmount?: number;
  percentage?: number;
  categories?: PurchasesTracesMonthCategoryStatistics[];

  constructor(json?: any) {
    if (!json) return;
    this.month = json.month;
    this.name = json.name;
    this.count = json.count;
    this.totalAmount = AppJsonDecoder.optPriceValue(json.totalAmount);
    this.percentage = json.percentage;
    this.categories = (json.categories || []).map(
      (json: any) => new PurchasesTracesMonthCategoryStatistics(json)
    );
  }
}

export class PurchasesTracesStatistics {
  year?: number;
  yearlyTotal?: number;
  months?: PurchasesTracesMonthStatistics[];
  categories?: PurchasesTracesCategoryStatistics[];

  constructor(json?: any) {
    if (!json) return;
    this.year = json.year;
    this.yearlyTotal = AppJsonDecoder.optPriceValue(json.yearlyTotal);
    this.months = (json.months || []).map(
      (json: any) => new PurchasesTracesMonthStatistics(json)
    );
    this.categories = (json.categories || []).map(
      (json: any) => new PurchasesTracesCategoryStatistics(json)
    );
  }
}
